module.exports = __webpack_public_path__ + "img/2.ac235a54.png";